// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Zk130","white":"Button_white__kgZ0f"};